import { EndFreeSpinsPopupComponent, EndFreeSpinsPopupView } from '@cgs/machines';
import { CorsicaEndFreeSpinsPopupController } from './corsica-end-free-spins-popup.controller';

export class CorsicaEndFreeSpinsPopupComponent extends EndFreeSpinsPopupComponent {
  protected createComponents() {
    this._view = new EndFreeSpinsPopupView(
      this.container,
      this.rootScene,
      this.popupScene,
      this.params
    );
    this.popupController = new CorsicaEndFreeSpinsPopupController(
      this.container,
      this._view,
      this.params
    );
  }
}
